import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createBlock as _createBlock, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, toHandlers as _toHandlers, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-120775bd"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "text-negative"
}
const _hoisted_2 = { class: "text-body1 text-grey-dark" }
const _hoisted_3 = { class: "text-body1 text-grey-dark" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_radio = _resolveComponent("q-radio")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_select = _resolveComponent("q-select")!

  return (_openBlock(), _createBlock(_component_q_select, _mergeProps({
    autofocus: "",
    disable: _ctx.disable,
    "input-class": "text-body1 text-primary-darker",
    "model-value": _ctx.modelValue,
    placeholder: _ctx.hidePlaceholder ? '' : _ctx.placeholderValue,
    class: ["iuf-select", { 'iuf-select-no-dropdown-icon': _ctx.noDropdownIcon }],
    "hide-bottom-space": "",
    ref: "iufSelect",
    behavior: "menu"
  }, _ctx.$props, { "options-dense": "" }, _toHandlers(_ctx.useInput ? { filter: _ctx.filter } : {}), {
    onAdd: _ctx.add,
    onPopupHide: _ctx.emitOptionsHide,
    onInputValue: _ctx.inputValue,
    onRemove: _ctx.remove,
    "onUpdate:modelValue": _ctx.updateModel
  }), _createSlots({
    error: _withCtx(() => [
      _renderSlot(_ctx.$slots, "error", {}, undefined, true)
    ]),
    option: _withCtx((scope) => [
      _createVNode(_component_q_item, {
        dense: "",
        tag: scope.opt.nonSelectableOption ? 'div' : 'label',
        class: _normalizeClass(["rounded-borders q-mt-xs q-px-none items-center", { active: scope.selected }])
      }, {
        default: _withCtx(() => [
          (!scope.opt.nonSelectableOption)
            ? (_openBlock(), _createBlock(_component_q_item_section, {
                key: 0,
                side: "",
                style: 'min-width:auto',
                class: "no-padding"
              }, {
                default: _withCtx(() => [
                  (_ctx.multiple)
                    ? (_openBlock(), _createBlock(_component_q_checkbox, _mergeProps({
                        key: 0,
                        class: "q-pr-sm",
                        clickable: "",
                        onClick: ($event: any) => (scope.toggleOption(scope.opt))
                      }, _ctx.CHECKBOX_PROPS, {
                        "model-value": scope.selected
                      }), null, 16, ["onClick", "model-value"]))
                    : (_openBlock(), _createBlock(_component_q_radio, _mergeProps({
                        key: 1,
                        "model-value": _ctx.selectedValue,
                        val: _ctx.valueForOption(scope.opt),
                        onClick: ($event: any) => (scope.toggleOption(scope.opt))
                      }, _ctx.RADIO_PROPS), null, 16, ["model-value", "val", "onClick"]))
                ]),
                _: 2
              }, 1024))
            : _createCommentVNode("", true),
          (!scope.opt.nonSelectableOption)
            ? _renderSlot(_ctx.$slots, "option", _normalizeProps(_mergeProps({ key: 1 }, scope)), () => [
                _createVNode(_component_q_item_section, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_item_label, _mergeProps({ lines: 1 }, _ctx.TEXT_CONTENT_BODY), {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.labelForOption(scope.opt)), 1)
                      ]),
                      _: 2
                    }, 1040)
                  ]),
                  _: 2
                }, 1024)
              ], true)
            : (_openBlock(), _createBlock(_component_q_item_section, { key: 2 }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_item_label, _normalizeProps(_guardReactiveProps(_ctx.nonSelectableOptionStyle ? _ctx.TEXT_OVERLINE : { class: 'section-overline' })), {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(scope.opt.label), 1)
                    ]),
                    _: 2
                  }, 1040)
                ]),
                _: 2
              }, 1024)),
          (!scope.opt.nonSelectableOption && !_ctx.noTooltip)
            ? (_openBlock(), _createBlock(_component_q_tooltip, _normalizeProps(_mergeProps({ key: 3 }, Object.assign({}, _ctx.TOOLTIP_PROPS, { anchor: 'bottom middle', self: 'top middle', offset: [0, 4] }))), {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.labelForOption(scope.opt)), 1)
                ]),
                _: 2
              }, 1040))
            : _createCommentVNode("", true)
        ]),
        _: 2
      }, 1032, ["tag", "class"])
    ]),
    _: 2
  }, [
    (_ctx.labelSlot || _ctx.label)
      ? {
          name: "label",
          fn: _withCtx(() => [
            _renderSlot(_ctx.$slots, "label", {}, () => [
              _createElementVNode("div", _normalizeProps(_guardReactiveProps(_ctx.TEXT_HEADER_BODY)), [
                _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
                (_ctx.mandatory)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.t('MANDATORY')), 1))
                  : _createCommentVNode("", true)
              ], 16)
            ], true)
          ]),
          key: "0"
        }
      : undefined,
    (_ctx.prependSlot || (!_ctx.useInput && _ctx.placeholderValue && (_ctx.selectedValue === undefined || _ctx.selectedValue === null)))
      ? {
          name: "prepend",
          fn: _withCtx(() => [
            (_ctx.prependSlot)
              ? _renderSlot(_ctx.$slots, "prepend", { key: 0 }, undefined, true)
              : _createCommentVNode("", true),
            (!_ctx.useInput && _ctx.placeholderValue && (_ctx.selectedValue === undefined || _ctx.selectedValue === null))
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass([{ 'q-pl-sm': _ctx.prependSlot }, "placeholder"])
                }, _toDisplayString(_ctx.placeholderValue), 3))
              : _createCommentVNode("", true)
          ]),
          key: "1"
        }
      : undefined,
    (_ctx.selectedItemSlot)
      ? {
          name: "selected-item",
          fn: _withCtx((scope) => [
            _renderSlot(_ctx.$slots, "selected-item", _normalizeProps(_guardReactiveProps(scope)), undefined, true)
          ]),
          key: "2"
        }
      : undefined,
    (_ctx.selectedSlot)
      ? {
          name: "selected",
          fn: _withCtx(() => [
            _renderSlot(_ctx.$slots, "selected", {}, undefined, true)
          ]),
          key: "3"
        }
      : undefined,
    (_ctx.removable || _ctx.appendSlot)
      ? {
          name: "append",
          fn: _withCtx(() => [
            (_ctx.appendSlot)
              ? _renderSlot(_ctx.$slots, "append", { key: 0 }, undefined, true)
              : _createCommentVNode("", true),
            (_ctx.removable && _ctx.modelValue)
              ? (_openBlock(), _createBlock(_component_q_icon, {
                  key: 1,
                  name: _ctx.ICONS_NAME.TIMES_CIRCLE_SOLID,
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.updateModel(null)), ["stop","prevent"]))
                }, null, 8, ["name"]))
              : _createCommentVNode("", true)
          ]),
          key: "4"
        }
      : undefined,
    (_ctx.hintSlot)
      ? {
          name: "hint",
          fn: _withCtx(() => [
            _renderSlot(_ctx.$slots, "hint", {}, undefined, true)
          ]),
          key: "5"
        }
      : undefined,
    (_ctx.beforeOptionsSlot)
      ? {
          name: "before-options",
          fn: _withCtx(() => [
            _renderSlot(_ctx.$slots, "before-options", {}, undefined, true)
          ]),
          key: "6"
        }
      : undefined,
    (_ctx.afterOptionsSlot || _ctx.allowCreate)
      ? {
          name: "after-options",
          fn: _withCtx(() => [
            _renderSlot(_ctx.$slots, "after-options", {}, () => [
              _createVNode(_component_q_separator, { class: "add-separator q-mt-sm" }),
              _createVNode(_component_q_item, { class: "q-pt-md" }, {
                default: _withCtx(() => [
                  (!_ctx.noAfterMessage)
                    ? (_openBlock(), _createBlock(_component_q_item_section, { key: 0 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_label, _mergeProps({ lines: 2 }, _ctx.TEXT_CONTENT_BODY), {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.afterMessage), 1)
                            ]),
                            _: 1
                          }, 16)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_q_item_section, {
                    side: _ctx.noAfterMessage ? false : true
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_btn, _mergeProps({
                        disable: (!_ctx.isSearching || !_ctx.allowCreate) && !_ctx.alwaysAllowCreate
                      }, _ctx.BTN_SECONDARY_MD, { onClick: _ctx.createValue }), {
                        default: _withCtx(() => [
                          _createVNode(_component_q_icon, {
                            name: _ctx.ICONS_NAME.PLUS_OUTLINE,
                            color: "grey-dark"
                          }, null, 8, ["name"]),
                          _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.allowCreateBtnLabel), 1)
                        ]),
                        _: 1
                      }, 16, ["disable", "onClick"])
                    ]),
                    _: 1
                  }, 8, ["side"])
                ]),
                _: 1
              })
            ], true)
          ]),
          key: "7"
        }
      : undefined,
    (_ctx.noOptionSlot || _ctx.allowCreate)
      ? {
          name: "no-option",
          fn: _withCtx(() => [
            _renderSlot(_ctx.$slots, "no-option", {}, () => [
              _createVNode(_component_q_item, null, {
                default: _withCtx(() => [
                  (!_ctx.noAfterMessage)
                    ? (_openBlock(), _createBlock(_component_q_item_section, { key: 0 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_label, _mergeProps({ lines: 2 }, _ctx.TEXT_CONTENT_BODY), {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.afterMessage), 1)
                            ]),
                            _: 1
                          }, 16)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_q_item_section, {
                    side: _ctx.noAfterMessage ? false : true
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_btn, _mergeProps({
                        disable: (!_ctx.isSearching || !_ctx.allowCreate) && !_ctx.alwaysAllowCreate
                      }, _ctx.BTN_SECONDARY_MD, { onClick: _ctx.createValue }), {
                        default: _withCtx(() => [
                          _createVNode(_component_q_icon, {
                            name: _ctx.ICONS_NAME.PLUS_OUTLINE,
                            color: "grey-dark"
                          }, null, 8, ["name"]),
                          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.allowCreateBtnLabel), 1)
                        ]),
                        _: 1
                      }, 16, ["disable", "onClick"])
                    ]),
                    _: 1
                  }, 8, ["side"])
                ]),
                _: 1
              })
            ], true)
          ]),
          key: "8"
        }
      : undefined
  ]), 1040, ["disable", "model-value", "placeholder", "class", "onAdd", "onPopupHide", "onInputValue", "onRemove", "onUpdate:modelValue"]))
}